"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuItems = _interopRequireDefault(require("./MenuItems"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var drawerWidth = 240;

var styles = function styles(theme) {
  return {
    drawerPaper: _defineProperty({
      backgroundColor: theme.palette.primary.main,
      width: drawerWidth
    }, theme.breakpoints.up('md'), {
      position: 'relative'
    }),
    logo: {
      backgroundColor: theme.palette.primary.main,
      padding: '1rem 0.875rem',
      '& img': {
        display: 'block',
        height: '2rem'
      }
    }
  };
};

var MyDrawer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MyDrawer, _React$Component);

  function MyDrawer() {
    _classCallCheck(this, MyDrawer);

    return _possibleConstructorReturn(this, _getPrototypeOf(MyDrawer).apply(this, arguments));
  }

  _createClass(MyDrawer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          currentPath = _this$props.currentPath,
          logo = _this$props.logo,
          onClose = _this$props.onClose,
          handleItemClick = _this$props.handleItemClick,
          items = _this$props.items,
          open = _this$props.open,
          variant = _this$props.variant;
      return _react["default"].createElement(_Drawer["default"], {
        anchor: "left",
        classes: {
          paper: classes.drawerPaper
        },
        ModalProps: {
          keepMounted: true
        },
        onClose: onClose,
        open: open,
        variant: variant
      }, _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: classes.logo
      }, _react["default"].createElement("img", {
        src: logo
      })), _react["default"].createElement(_MenuItems["default"], {
        currentPath: currentPath,
        items: items,
        handleItemClick: handleItemClick
      })));
    }
  }]);

  return MyDrawer;
}(_react["default"].Component);

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(MyDrawer);

exports["default"] = _default;